import { render } from "./Contracts.vue?vue&type=template&id=5558c8c0&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"

import "./Contracts.vue?vue&type=style&index=0&id=5558c8c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5558c8c0"

export default script